<h2 mat-dialog-title>{{ 'FRONTEND.SALES_UI.PIPELINE.EXPORT_AS_CSV' | translate }}</h2>

<form [formGroup]="exportForm" (ngSubmit)="onSubmit()">
  <mat-dialog-content class="export-csv-content">
    <strong>{{ 'FRONTEND.SALES_UI.PIPELINE.TABLE.EXPORT_CSV.TITLE' | translate }}</strong>
    <div>
      <mat-checkbox formControlName="opportunities">
        {{ 'FRONTEND.SALES_UI.PIPELINE.TABLE.EXPORT_CSV.PIPELINE' | translate }}
      </mat-checkbox>
    </div>
    <div>
      <mat-checkbox formControlName="history">
        {{ 'FRONTEND.SALES_UI.PIPELINE.TABLE.EXPORT_CSV.OPPORTUNITY_HISTORY' | translate }}
      </mat-checkbox>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button color="primary" mat-button mat-dialog-close>
      {{ 'FRONTEND.SALES_UI.COMMON.ACTION_LABELS.CANCEL' | translate }}
    </button>
    <button type="submit" [disabled]="!exportForm.valid" color="primary" mat-raised-button>
      <glxy-button-loading-indicator [isLoading]="isLoading$ | async">
        {{ 'FRONTEND.SALES_UI.COMMON.ACTION_LABELS.EXPORT' | translate }}
      </glxy-button-loading-indicator>
    </button>
  </mat-dialog-actions>
</form>
